/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable complexity , sonarjs/cognitive-complexity */
import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import {
  getIconPath,
  getLocator,
  isCanada,
  getBrand,
  getImageData,
  getUpdatedSizeName,
} from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import {
  capitalizeWords,
  getBrandNameFromHref,
  getIsLoggedInUser,
} from '@tcp/core/src/utils/utils';
import CartItemTileLabels, {
  GLOBAL_LABELS,
} from '@tcp/core/src/components/features/CnC/CartItemTile/molecules/CartItemTile/views/CartItemTile.labels.js';
import DamImage from '../../../../../../common/atoms/DamImage';
import ProductInformationRedesignStyle from '../styles/ProductInformationRedesign.style';
import CartOfferToolTipView from '../../../../CartItemTile/molecules/CartOfferToolTip/views/CartOfferToolTip.view';
import InputCheckbox from '../../../../../../common/atoms/InputCheckbox';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GlobalAddToBagLabels,
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from '../../../../../../../utils/labels/globalAddedToBag.labels';
import {
  GlobalAccessibilityLabels,
  GLOBAL_ACCESSIBILITY_LABELS,
} from '../../../../../../../utils/labels/globalAccessibility.labels';

const ProductInformationAccessories = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "ProductInformationAccessories" */ '../../ProductInformationAccessories/views/ProductInformationAccessories.view'
  )
);

const getColConfig = () => {
  return { small: 4.3, medium: 5.5, large: 8.5 };
};

const showPoints = (isInternationalShipping, isGiftCard) => {
  return isGiftCard || (!isCanada() && !isInternationalShipping);
};

const showItemPoints = (
  bagLoading,
  data,
  quant,
  isAccessoriesIncluded,
  loyaltyOrderItemPoints,
  isLoyaltyTieringEnabled
) => {
  // TODO: Logic to calculate/fetch may change later based on API response.
  let itemPoints = data?.itemPoints || 0;
  // Only show API fetched points if its pdp page and loyalty tiering is enabled else use older calculations to show points.
  if (isLoyaltyTieringEnabled && data?.isPdpPage) {
    const { skuInfo } = data;
    const { productId } = skuInfo;
    if (loyaltyOrderItemPoints?.items?.length > 1) {
      itemPoints = loyaltyOrderItemPoints?.items?.filter((item) => item.itemId === productId)[0]
        ?.rewardPoints;
    } else {
      itemPoints = loyaltyOrderItemPoints?.items[0]?.rewardPoints;
    }
  } else if (isAccessoriesIncluded) {
    // let itemPoints = data?.itemPoints || 0;
    const { orderItems = [] } = data;
    let mainItemPoint = data?.itemPoints || 0;
    if (orderItems) {
      orderItems.forEach((item) => {
        const { itemInfo } = item || {};
        const { itemId } = itemInfo || [];
        const { quantity } = itemInfo || [];
        if (itemId === data?.orderItemId) {
          mainItemPoint = itemInfo?.itemPoints / quantity;
        }
      });
      itemPoints = mainItemPoint * quant;
    }
  }
  itemPoints = itemPoints || 0;
  return !bagLoading ? Math.round(itemPoints) : <LoaderSkelton width="20px" />;
};

const getPointsColor = (isPlcc) => {
  if (isPlcc) {
    return 'blue.B100';
  }
  return 'orange.800';
};

const showItemBrand = (data) => {
  return !data.isGiftCard && data.brand;
};

const setBrandIfNotPresent = (data, primaryBrand, alternateBrandParam) => {
  const alternateBrand = getBrandNameFromHref();
  const dataInfo = data;
  const brand = getBrand();
  dataInfo.brand = primaryBrand || alternateBrand || alternateBrandParam || dataInfo.brand || brand;
  dataInfo.brand = (dataInfo.brand || '').toUpperCase();
};

const getSizeAndQty = (data, isATBModalBackAbTestNewDesign, quantity) => {
  const addedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );
  return `${quantity || data.quantity} ${renderLabel(
    addedToBagLabels?.lbl_info_Qty,
    'lbl_info_Qty'
  )}`;
};

const getSeparator = () => {
  return (
    <BodyCopy
      component="span"
      fontSize="fs13"
      textAlign="left"
      className="content-separator"
      color="gray.500"
      dataLocator="addedtobag-productsize"
      fontFamily="secondary"
    >
      {'| '}
    </BodyCopy>
  );
};

const getSingleItemPrice = (bagLoading, itemPrice, offerPrice, singleItemAfterDiscountPrice) => {
  return !bagLoading && (singleItemAfterDiscountPrice || itemPrice || offerPrice) ? (
    <PriceCurrency price={singleItemAfterDiscountPrice || itemPrice || offerPrice} />
  ) : (
    '-'
  );
};

const getMainProductIds = (mainProducts) => {
  if (mainProducts && mainProducts.length) {
    return mainProducts.map((mainProduct) => {
      return mainProduct.split('#')[0];
    });
  }
  return [];
};

const getPrice = (loyaltyOrderItems = [], data, addedQuantity) => {
  const parentId = data?.skuInfo?.variantId;
  let totalPrice = 0;

  loyaltyOrderItems.map((item) => {
    if (item?.productId === parentId) {
      totalPrice = addedQuantity * (item?.priceAfterOrderDiscount / item?.quantity);
    }
    return null;
  });

  return totalPrice;
};

const getPriceWithAccessories = (loyaltyOrderItems = [], data, quantity = 1, itemInfo) => {
  const { accessories = [] } = itemInfo;
  const accessoriesSelected = [];
  for (let i = 0; i < accessories.length; i += 1) {
    accessoriesSelected.push(accessories[i]?.skuInfo?.variantId);
  }
  const addedQuantity = quantity || data.quantity;
  const priceToShowOfferPrice =
    addedQuantity * data?.skuInfo?.offerPrice || addedQuantity * data?.skuInfo?.listPrice;
  const priceToShow = getPrice(loyaltyOrderItems, data, addedQuantity) || priceToShowOfferPrice;
  const variantId = data?.skuInfo?.variantId;
  const includedAccessory = loyaltyOrderItems.filter((item) => {
    const mainProductIds = getMainProductIds(item?.c_mainProducts);
    return (
      item.c_priceIncluded &&
      mainProductIds.indexOf(variantId) > -1 &&
      item?.c_TCPStyleType === '0007' &&
      accessoriesSelected.includes(item?.productId)
    );
  });
  const accessoryPrice =
    includedAccessory &&
    includedAccessory.reduce((acc, item) => {
      const accessoyPrice = addedQuantity * (item?.priceAfterOrderDiscount / item?.quantity);
      return acc + accessoyPrice;
    }, 0);
  let secondaryAccessoryTotalPrice = 0;

  if (includedAccessory && includedAccessory.length) {
    includedAccessory.forEach((firstAccessory) => {
      const secondaryIncludedAccessory = loyaltyOrderItems.filter((item) => {
        const mainProductIds = getMainProductIds(item?.c_mainProducts);
        return (
          item.c_priceIncluded &&
          mainProductIds.indexOf(firstAccessory?.productId) > -1 &&
          item?.c_TCPStyleType === '0007'
        );
      });
      const secondaryAccessoryPrice =
        secondaryIncludedAccessory &&
        secondaryIncludedAccessory.reduce((acc, item) => {
          const accessoyPrice = addedQuantity * (item?.priceAfterOrderDiscount / item?.quantity);
          return acc + accessoyPrice;
        }, 0);
      secondaryAccessoryTotalPrice += secondaryAccessoryPrice;
    });
  }

  const totalPrice = priceToShow + accessoryPrice + secondaryAccessoryTotalPrice;
  return <PriceCurrency price={totalPrice} />;
};

const getSingleItemPriceAfterDiscount = (data) => {
  const { orderItemId = '' } = data || {};
  const { loyaltyOrderItems = [] } = data || {};

  let price = 0;
  loyaltyOrderItems.map((item) => {
    if (item?.itemId === orderItemId) {
      price = item?.priceAfterOrderDiscount;
    }
    return null;
  });
  return price;
};

const getPointsData = (
  isPlcc,
  bagLoading,
  data,
  isLoyaltyPointsEnabled,
  quantity,
  isAccessoriesIncluded,
  loyaltyOrderItemPoints,
  isLoyaltyTieringEnabled
) => {
  const addedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );
  const { isGiftCard, itemPoints } = data;
  const displayPoints = isGiftCard || itemPoints;
  return isLoyaltyPointsEnabled ? (
    <>
      {getSeparator()}
      <BodyCopy
        fontSize="fs12"
        fontFamily="secondary"
        className="text-value double-points"
        color={getPointsColor(isPlcc)}
        fontWeight="extrabold"
      >
        {!isGiftCard
          ? showItemPoints(
              bagLoading,
              data,
              quantity,
              isAccessoriesIncluded,
              loyaltyOrderItemPoints,
              isLoyaltyTieringEnabled
            )
          : '0'}
      </BodyCopy>
      {displayPoints && (
        <BodyCopy
          component="span"
          fontSize="fs12"
          fontFamily="secondary"
          className="text-value"
          fontWeight="medium"
        >
          {renderLabel(addedToBagLabels?.lbl_info_item_points, 'lbl_info_item_points')}
        </BodyCopy>
      )}
    </>
  ) : null;
};

const getFormattedColorName = (color) => {
  let colorName;
  if (typeof color === 'string') {
    colorName = color.split('-')?.[0];
  }
  return colorName || color;
};

const getSize = ({ size, currentBrand, isHardcodeSizeMapEnabled, hardcodeSizeMapConfig }) => {
  const updatedSizeValue = getUpdatedSizeName({
    size,
    primaryBrand: currentBrand,
    killSwitch: isHardcodeSizeMapEnabled,
    sizeMap: hardcodeSizeMapConfig,
  });
  return updatedSizeValue || size;
};

const ProductInformationRedesign = ({
  data,
  inheritedStyles,
  quantity,
  bagLoading,
  hasDoubleItems,
  isInternationalShipping,
  isATBModalBackAbTestNewDesign,
  primaryBrand,
  alternateBrand,
  isPlcc,
  loyaltyOrderItems: loyaltyOrderItemsArray,
  isOffersDisplayEnabled,
  currencyAttributes,
  isLoyaltyPointsEnabled,
  isCarouselIncluded,
  itemInfo,
  isCarousel,
  isUserPersonalizationApiEnabled,
  saveUserPreferences,
  router,
  isHardcodeSizeMapEnabled,
  hardcodeSizeMapConfig,
  subTotalComponent,
  bagSubTotal,
  isNewATBProductInformationDesignEnabled,
  offerPriceIsLoading,
  loyaltyOrderItemPoints,
  isLoyaltyTieringEnabled,
}) => {
  const addedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );

  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, CartItemTileLabels);

  const { cartItemTile } = globalLabels || {};

  const [isChecked, setIsChecked] = useState(false);
  const loyaltyOrderItems = loyaltyOrderItemsArray || [];
  const singleItemAfterDiscountPrice = getSingleItemPriceAfterDiscount(data);
  const isOutFitPage = router && router?.asPath?.split('/').includes('outfit');

  const isAccessoriesIncluded = itemInfo && itemInfo.accessories && itemInfo.accessories.length;
  setBrandIfNotPresent(data, primaryBrand, alternateBrand);
  let { imageUrl } = data && data.skuInfo;
  const { colorProductId } = data.skuInfo;
  if (imageUrl && imageUrl.includes('wcsstore')) {
    const dataImageObj = imageUrl.split('/');
    imageUrl = dataImageObj.length ? dataImageObj[dataImageObj.length - 1] : imageUrl;
    imageUrl =
      colorProductId.split('_') && colorProductId.split('_').length
        ? `${colorProductId.split('_')[0]}/${imageUrl}`
        : imageUrl;
  }
  const configData = getImageData(imageUrl);
  const { itemPrice, isGiftCard, skuInfo: { offerPrice } = {} } = data;
  const itemPriceValue = currencyConversion(itemPrice, currencyAttributes);
  const offerPriceValue = currencyConversion(offerPrice, currencyAttributes);
  const singleItemAfterDiscountPriceValue = currencyConversion(
    singleItemAfterDiscountPrice,
    currencyAttributes
  );
  // eslint-disable-next-line no-nested-ternary
  const priceToShow = isAccessoriesIncluded
    ? getPriceWithAccessories(loyaltyOrderItems, data, quantity, itemInfo)
    : getSingleItemPrice(
        bagLoading,
        itemPriceValue,
        offerPriceValue,
        singleItemAfterDiscountPriceValue
      );
  const itemOffersInfo = {
    price: null,
    priceAfterOrderDiscount: null,
    priceAdjustments: null,
    priceAfterItemDiscount: null,
  };
  let indexInLoyalityOrderItem = 0;
  if (loyaltyOrderItems && loyaltyOrderItems?.length) {
    loyaltyOrderItems.forEach((item, index) => {
      if (item.productId === data.skuInfo.variantId) {
        indexInLoyalityOrderItem = index;
      }
      const targetProductOrderType = data?.pickupType || 'ecom';
      if (
        item.productId === data.skuInfo.variantId &&
        item?.c_orderItemType?.toLowerCase() === targetProductOrderType
      ) {
        const { priceAdjustments, price, priceAfterOrderDiscount, priceAfterItemDiscount } =
          item || {};
        itemOffersInfo.priceAdjustments = priceAdjustments;
        itemOffersInfo.price = price;
        itemOffersInfo.priceAfterOrderDiscount = priceAfterOrderDiscount;
        itemOffersInfo.priceAfterItemDiscount = priceAfterItemDiscount;
      }
    });
  }

  const handleSaveSizeChange = () => {
    setIsChecked(!isChecked);
    saveUserPreferences(!isChecked);
  };

  const currentBrand = itemInfo.primaryBrand || data.brand || itemInfo.alternateBrand;
  let accessoryImageUrl;
  if (itemInfo && itemInfo?.accessories?.length > 0) {
    const { imageUrl: accessoryImg } = itemInfo && itemInfo?.accessories?.[0]?.skuInfo;
    accessoryImageUrl = accessoryImg;
  }

  return (
    <>
      {!isNewATBProductInformationDesignEnabled ? (
        <ProductInformationRedesignStyle
          inheritedStyles={inheritedStyles}
          isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
          hasDoubleItems={hasDoubleItems}
          isCarouselIncluded={isCarouselIncluded}
        >
          <Row
            tagName="ul"
            className={`product product-detail-container ${hasDoubleItems ? 'multi-item' : ''} ${
              itemInfo && itemInfo?.accessories?.length > 0 ? 'style-with-accessories' : ''
            }`}
            fullBleed
          >
            <Col
              tagName="li"
              key="productDetails"
              className="product-logo"
              colSize={{ small: 2, medium: 2, large: 3 }}
            >
              <DamImage
                imgData={{
                  alt: 'Product',
                  url: imageUrl,
                }}
                imgConfigs={configData.imgConfig}
                className="product-image"
                data-locator="addedtobag-productimage"
                isProductImage
                itemBrand={itemInfo.primaryBrand || data.brand || itemInfo.alternateBrand}
                isOptimizedVideo
                fromFavorites={data?.fromFavorites}
                isAddedToBagModal
              />
              {showItemBrand(data) && (
                <Image
                  className="brand-image"
                  src={getIconPath(
                    `header__brand-tab-${(
                      itemInfo.primaryBrand ||
                      data.brand ||
                      itemInfo.alternateBrand
                    ).toLowerCase()}`
                  )}
                  alt={getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACCESSIBILITY_LABELS}.lbl_brandlogo_${(
                      itemInfo.primaryBrand ||
                      data.brand ||
                      itemInfo.alternateBrand
                    )?.toLowerCase()}AltText`,
                    GlobalAccessibilityLabels
                  )}
                  data-locator={getLocator('header__brand-tab--tcp')}
                />
              )}
            </Col>
            <Col
              tagName="li"
              key="productDetails"
              colSize={getColConfig()}
              className="atb-product-detail-section"
            >
              <Row tagName="ul" className="product-details">
                <Col
                  tagName="li"
                  key="product-title"
                  className="productImgBrand"
                  colSize={{ small: 6, medium: 8, large: 12 }}
                >
                  <BodyCopy
                    tag="span"
                    fontSize="fs14"
                    fontWeight="bold"
                    textAlign="left"
                    className="product-online-exclusive-tag"
                    dataLocator="addedtobag-productname"
                    fontFamily="secondary"
                  >
                    {data.isOnlineExclusive}
                  </BodyCopy>
                  <BodyCopy
                    tag="span"
                    fontSize="fs14"
                    fontWeight="bold"
                    textAlign="left"
                    className="product-title"
                    dataLocator="addedtobag-productname"
                    fontFamily="secondary"
                  >
                    {data.productName}
                  </BodyCopy>
                </Col>
              </Row>
              <Row tagName="ul" className="product-description">
                <Col
                  tagName="li"
                  key="product-title"
                  className="itemList"
                  colSize={{ small: 7, medium: 8, large: 12 }}
                >
                  <BodyCopy
                    tag="span"
                    fontSize="fs12"
                    textAlign="left"
                    className="itemDesc"
                    dataLocator="addedtobag-productcolor"
                    fontFamily="secondary"
                  >
                    {capitalizeWords(getFormattedColorName(data.skuInfo.color.name))}
                    {getSeparator()}
                    {getSize({
                      size: data.skuInfo.size,
                      currentBrand,
                      isHardcodeSizeMapEnabled,
                      hardcodeSizeMapConfig,
                    })}
                  </BodyCopy>

                  <BodyCopy
                    tag="span"
                    fontSize="fs12"
                    textAlign="left"
                    className="itemDesc"
                    dataLocator="addedtobag-productsize"
                    fontFamily="secondary"
                  >
                    {getSizeAndQty(data, isATBModalBackAbTestNewDesign, quantity)}
                    {showPoints(isInternationalShipping, isGiftCard) &&
                      getPointsData(
                        isPlcc,
                        bagLoading,
                        data,
                        isLoyaltyPointsEnabled,
                        quantity,
                        isAccessoriesIncluded,
                        loyaltyOrderItemPoints,
                        isLoyaltyTieringEnabled
                      )}
                  </BodyCopy>
                  <BodyCopy
                    tag="span"
                    textAlign="left"
                    className="product-price"
                    dataLocator="addedtobag-productprice"
                    fontFamily="secondary"
                  >
                    {data?.c_priceIncluded && data?.skuInfo?.TCPStyleType === '0007'
                      ? renderLabel(
                          cartItemTile.lbl_accessory_price_included,
                          'lbl_accessory_price_included'
                        )
                      : priceToShow}
                  </BodyCopy>
                  {getIsLoggedInUser() &&
                    isUserPersonalizationApiEnabled &&
                    !isOutFitPage &&
                    !isCarouselIncluded && (
                      <BodyCopy component="div" className="saveSize-check">
                        <InputCheckbox
                          dataLocator="data-locator"
                          fontSize="fs14"
                          input={{
                            value: isChecked,
                            name: 'saveSizeCheck',
                            onChange: () => handleSaveSizeChange(),
                          }}
                        >
                          <BodyCopy
                            fontFamily="secondary"
                            tag="span"
                            className="elem-mb-XXS remember-me-text"
                            fontSize="fs12"
                          >
                            {renderLabel(
                              addedToBagLabels?.lbl_remember_preference,
                              'lbl_remember_preference'
                            )}
                          </BodyCopy>
                        </InputCheckbox>
                      </BodyCopy>
                    )}
                </Col>
              </Row>
            </Col>
            <BodyCopy className="promotion-label-container">
              {isOffersDisplayEnabled && (
                <CartOfferToolTipView
                  itemOffersInfo={itemOffersInfo}
                  itemIndex={indexInLoyalityOrderItem}
                  orderPriceAdjustments={[]}
                  isATBModalBackAbTestNewDesign
                  isCarouselIncluded={isCarouselIncluded}
                  offerPriceIsLoading={offerPriceIsLoading}
                />
              )}
            </BodyCopy>
            {itemInfo && itemInfo?.accessories?.length > 0 && (
              <ProductInformationAccessories
                isMandatoryCustomization
                data={itemInfo}
                variantId={data?.skuInfo?.variantId}
                productId={data?.skuInfo?.productId}
                isCarousel={isCarousel}
                pointsColor={getPointsColor(isPlcc)}
                getSeparator={getSeparator}
              />
            )}
          </Row>
        </ProductInformationRedesignStyle>
      ) : (
        <ProductInformationRedesignStyle
          inheritedStyles={inheritedStyles}
          isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
          hasDoubleItems={hasDoubleItems}
          isCarouselIncluded={isCarouselIncluded}
        >
          <div
            className={
              itemInfo?.accessories?.length > 0
                ? 'product-info-compact-design-with-accessory'
                : 'product-info-compact-design'
            }
          >
            <div className="left-component">
              <div className="text-component">
                <BodyCopy
                  tag="span"
                  fontSize="fs14"
                  fontWeight="demiBold"
                  textAlign="left"
                  className="sub-total-component"
                  dataLocator="addedtobag-productname"
                  fontFamily="secondary"
                >
                  Bag {subTotalComponent}
                </BodyCopy>
                <BodyCopy
                  fontFamily="secondary"
                  tag="span"
                  className="amount-component"
                  fontSize="fs16"
                  fontWeight="extrabold"
                >
                  {bagSubTotal && (
                    <PriceCurrency price={currencyConversion(bagSubTotal, currencyAttributes)} />
                  )}
                </BodyCopy>
              </div>
              <div className="divider-component" />
            </div>
            <div className="image-component-container">
              <div className="image-component">
                <DamImage
                  imgData={{
                    alt: 'Product',
                    url: imageUrl,
                  }}
                  imgConfigs={configData.imgConfig}
                  data-locator="addedtobag-productimage"
                  isProductImage
                  itemBrand={itemInfo.primaryBrand || data.brand || itemInfo.alternateBrand}
                  isOptimizedVideo
                  fromFavorites={data?.fromFavorites}
                />
              </div>
              {itemInfo && itemInfo?.accessories?.length > 0 && (
                <div className="image-component image-component-accessory">
                  <DamImage
                    imgData={{
                      alt: 'Product',
                      url: accessoryImageUrl,
                    }}
                    imgConfigs={configData?.imgConfig}
                    className="accessory-product-image"
                    data-locator="addedtobag-productimage"
                    isProductImage
                    itemBrand={primaryBrand || data?.brand || alternateBrand}
                    isOptimizedVideo
                    fromFavorites={data?.fromFavorites}
                  />
                </div>
              )}
            </div>
          </div>
        </ProductInformationRedesignStyle>
      )}
    </>
  );
};

ProductInformationRedesign.propTypes = {
  data: PropTypes.shape({}).isRequired,
  inheritedStyles: PropTypes.shape({}).isRequired,
  quantity: PropTypes.number.isRequired,
  isDoubleAddedToBag: PropTypes.bool.isRequired,
  bagLoading: PropTypes.bool.isRequired,
  hasDoubleItems: PropTypes.shape([]).isRequired,
  isSuppressGetOrderDetails: PropTypes.bool.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  isAvoidGetOrderDetails: PropTypes.bool.isRequired,
  isATBHidePoints: PropTypes.bool,
  isATBModalBackAbTestNewDesign: PropTypes.bool,
  loyaltyOrderItems: PropTypes.shape({}),
  loyaltyOrderItemPoints: PropTypes.shape({}),
  isLoyaltyTieringEnabled: PropTypes.bool,
  isAccessoriesIncluded: PropTypes.bool,
  isHardcodeSizeMapEnabled: PropTypes.bool,
  hardcodeSizeMapConfig: PropTypes.shape({}),
};

ProductInformationRedesign.defaultProps = {
  isATBHidePoints: false,
  isATBModalBackAbTestNewDesign: false,
  loyaltyOrderItems: null,
  loyaltyOrderItemPoints: null,
  isLoyaltyTieringEnabled: false,
  isAccessoriesIncluded: false,
  isHardcodeSizeMapEnabled: false,
  hardcodeSizeMapConfig: {},
};

export default errorBoundary(ProductInformationRedesign);
